import { customFetch } from "@/utils/fetch";

const getUrl = (relativeUrl: string, baseUrl: string): string => {
	const requestUrl = new URL(`${baseUrl}${relativeUrl}`);

	return requestUrl.toString();
};

export const accountApiFetcher = async <T>(
	url: string,
	options: RequestInit,
): Promise<T> => {
	return customFetch(getUrl(url, import.meta.env.VITE_ACCOUNT_API), options);
};

export const advertisingApiFetcher = async <T>(
	url: string,
	options: RequestInit,
): Promise<T> => {
	return customFetch(
		getUrl(url, import.meta.env.VITE_ADVERTISING_API),
		options,
	);
};

export const stationApiFetcher = async <T>(
	url: string,
	options: RequestInit,
): Promise<T> => {
	return customFetch(getUrl(url, import.meta.env.VITE_STATION_API), options);
};

export const statisticsApiFetcher = async <T>(
	url: string,
	options: RequestInit,
): Promise<T> => {
	return customFetch(getUrl(url, import.meta.env.VITE_STATISTICS_API), options);
};
